<ng-template cdkPortal>
  <div class="relative w-full bg-white rounded-lg p-6">
    <ng-content select="[dialog-header]"></ng-content>
    <ng-content select="[dialog-content]"></ng-content>
    <ng-content select="[dialog-footer]"></ng-content>
  </div>
</ng-template>
